import { Icon, Pagination } from "components";
import { config } from "constant";
import { FilesLoading, LinkCard, NoLink } from "containers";
import SelectRoomDrawer from "containers/SelectRoomDrawer";
import { useAxios, useToggle } from "hooks";
import { cloneDeep } from "lodash";
import { Fragment, useContext, useEffect, useState } from "react";
import { Link, Paged, Room } from "types";
import { PersonDetailsContext } from ".";

export default function Links() {
  const { user } = useContext(PersonDetailsContext);
  const [axios, loading] = useAxios();

  const [openSelectRoom, toggleSelectRoom] = useToggle(false);
  const [links, setLinks] = useState<Paged<Link.Item> | null>(null);
  const [activeRoom, setActiveRoom] = useState<Room.Item | null>(null);
  const [params, setParams] = useState<Link.Params>({
    pageSize: config.pageSize,
    pageNumber: 1,
    roomId: null,
  });
  const hasLinks = !!links?.items.length || !!loading;
  const handleSetParams = (key: keyof Link.Params) => {
    return (value: any) => {
      const isPageNumber = key === "pageNumber";
      setParams((p) => ({
        ...p,
        [key]: value,
        ...(!isPageNumber && { pageNumber: 1 }),
      }));
    };
  };
  const getLinks = () => {
    const url = `/People/${user.id}/get-all-public-links`;
    const config = { params: cloneDeep(params) };
    config.params.roomId = activeRoom?.id ?? null;
    const isFirstPage = config.params.pageNumber === 1;
    isFirstPage && setLinks(null);
    axios.get(url, config).then(({ data }) => {
      if (isFirstPage) return setLinks(data);
      setLinks((p) => ({ ...p!, items: [...p?.items!, ...data.items] }));
    });
  };

  useEffect(getLinks, [params, user.id, activeRoom]);
  return (
    <section className="px-5 space-y-2">
      <h2
        className="text-base text-[#353740] font-medium pb-3 cursor-pointer"
        onClick={toggleSelectRoom}
      >
        {activeRoom?.title ?? "All links"}{" "}
        <Icon name="ArrowDown2" variant="Bold" className="size-4" />
      </h2>
      <hr />
      {!hasLinks && <NoLink />}
      {links?.items.map((e) => (
        <Fragment key={e.id}>
          <LinkCard link={e} />
          <hr />
        </Fragment>
      ))}
      {loading ? (
        <FilesLoading />
      ) : (
        <Pagination
          activePage={params.pageNumber}
          setActivePage={handleSetParams("pageNumber")}
          totalPages={links?.totalPages}
        />
      )}
      <SelectRoomDrawer
        isOpen={openSelectRoom}
        toggle={toggleSelectRoom}
        activeRoom={activeRoom}
        onSelect={setActiveRoom}
      />
    </section>
  );
}
